export const range = (start, end) => {
  return [...Array(end + 1 - start).keys()].map((x) => x + start);
};

export const normalizeToIsoString = (value) => {
  if (value === undefined || value === null) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.toISOString();
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const epochMs = value < 1_000_000_000_000 ? value * 1000 : value;
    const d = new Date(epochMs);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;

    const asNumber = Number(trimmed);
    if (Number.isFinite(asNumber)) {
      const epochMs = asNumber < 1_000_000_000_000 ? asNumber * 1000 : asNumber;
      const d = new Date(epochMs);
      return Number.isNaN(d.getTime()) ? null : d.toISOString();
    }

    const direct = new Date(trimmed);
    if (!Number.isNaN(direct.getTime())) return direct.toISOString();

    const normalized = trimmed.replace(" ", "T").replace(/(\\.\\d{3})\\d+/, "$1");
    const coerced = new Date(normalized);
    return Number.isNaN(coerced.getTime()) ? null : coerced.toISOString();
  }

  return null;
};
